import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { TokenExtension } from '@utils/extensions/token.extension.ts';
import { PATHS } from '../../../router/paths.ts';
import { useNavigate } from 'react-router-dom';

export async function deleteAccount(): Promise<void> {
  await Axios.delete(DELETE_URL().deleteProfileAccount);
}

export function useDeleteUserAccount() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useMutation<void, AxiosError<BaseError>, any>(deleteAccount, {
    onSuccess: async () => {
      await queryClient.invalidateQueries('user');
      await queryClient.invalidateQueries(QueryKeys.login());
      TokenExtension.remove();
      navigate(PATHS().LOGIN);
    },
    useErrorBoundary: false
  });
}
